module.exports = __webpack_public_path__ + "img/alert-triangle.77ebc507.svg";